import { useCallback } from 'react';
import {
  rest,
  useUserInfo,
  useUserInfoContext,
} from '@xolv-mybrightlink/common';

export const useCareTeamSlaStatus = (): boolean => {
  const userInfo = useUserInfo();
  return userInfo.ccm_sla_acknowledged;
};

export const useAcceptCareTeamSla = () => {
  const [, dispatch] = useUserInfoContext();
  return useCallback(async () => {
    await rest.post('/user/update-ccm-sla-acknowledgement');
    dispatch({ type: 'CARE_TEAM_SLA_ACCEPTED' });
  }, [dispatch]);
};
